import { useMemo } from 'react';
import { Center, Spinner, Box } from '@chakra-ui/react';
import { DITable } from 'plugins/DITable';
import TablePagination from 'plugins/DITable/Pagination';
import useAliasContainer from './AliasContainer';
import AliasToolbar from './views/AliasToolbar';
import AliasEmpty from './views/AliasEmpty';
import AliasModalView from './views/modals/AliasModalView';

const LoadingArea = () => (
    <Center h="678px">
        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blueMain" size="xl" />
    </Center>
);

const MAliasesTab = () => {
    const props = useAliasContainer();
    const {
        isLoading,
        isGetAliasError,
        aliasesData,
        tableInstance,
        companyInfo,
        isExportLoading,
        readonly,
        onOpenAdd,
        exportAliases,
    } = props;

    const displayTable = useMemo(
        () => !isLoading && !isGetAliasError && aliasesData?.aliases && Object.entries(aliasesData.aliases).length > 0,
        [isLoading, isGetAliasError, aliasesData?.aliases],
    );

    return (
        <Box>
            {isLoading && <LoadingArea />}
            {displayTable ? (
                <Box mt="16px">
                    <AliasToolbar
                        {...{ tableInstance, exportAliases, companyInfo, isExportLoading, onOpenAdd, readonly }}
                    />
                    <DITable {...tableInstance} isPagination />
                    <TablePagination tableInstance={tableInstance} />
                </Box>
            ) : (
                <AliasEmpty {...props} />
            )}
            <AliasModalView {...props} />
        </Box>
    );
};

export default MAliasesTab;
